import axios from 'axios';

import {
  apiConfig,
} from '../store/index.js';

import { getHeaders } from './headers';

export function getItineraryById(id) {
  const { url, version } = apiConfig('itinerary', { itineraryId: id });

  const options = {
    url,
    method: 'GET',
    headers: getHeaders(true),
    apiVersion: version
  };

  return axios(options);
}

export function searchItineraries(params, cancelToken) {
  const { url, version } = apiConfig('itinerary', null, null, false);

  const options = {
    url,
    method: 'GET',
    headers: getHeaders(true),
    params,
    cancelToken,
    apiVersion: version
  };

  return axios(options);
}

export function newSearch(search) {
  const { url, version } = apiConfig('itinerary', null, null, false);
  const data = JSON.stringify(search);

  const options = {
    url,
    method: 'POST',
    headers: getHeaders(true),
    data,
    apiVersion: version
  };

  return axios(options);
}

export function getFareRules(params) {
  const url = `${config.API_URL}api/Itinerary/${params.itineraryId}/passenger/${params.passengerId}/${params.sectorType}/${params.sectorId}/farerules`;

  const options = {
    url,
    method: 'GET',
    headers: getHeaders(true)
  };

  return axios(options);
}

export function makeBooking(itinerary, preventGlobalError) {
  const { url, version } = apiConfig('itinerary', { itineraryId: itinerary.Identifier });
  const data = JSON.stringify(itinerary);

  const options = {
    url,
    method: 'PUT',
    headers: getHeaders(true),
    data,
    apiVersion: version,
    preventGlobalError
  };

  return axios(options);
}


export function addFlights(itineraryId, flights) {
  const { url, version } = apiConfig('addFlights', { itineraryId });
  const data = JSON.stringify(flights);

  const options = {
    url,
    method: 'POST',
    headers: getHeaders(true),
    data,
    apiVersion: version
  };

  return axios(options);
}
